export const formatPriceLakh = (rupees) => {
  if (rupees == null || isNaN(rupees)) return "—";
  const lakh = rupees / 100000;
  if (lakh >= 100) return `₹${(lakh / 100).toFixed(2)} Cr`;
  return `₹${lakh.toFixed(2)} Lakh`;
};

export const formatPriceFull = (rupees) => {
  if (rupees == null) return "—";
  return `₹${rupees.toLocaleString("en-IN")}`;
};

export const formatKm = (km) => `${(km || 0).toLocaleString("en-IN")} km`;

export const vehicleTitle = (v) => {
  const parts = [v.year, v.make, v.model].filter(Boolean);
  return parts.join(" ") + (v.variant ? ` ${v.variant}` : "");
};

export const buildWhatsAppLink = (number, message) => {
  const clean = (number || "").replace(/\D/g, "");
  const encoded = encodeURIComponent(message || "");
  return `https://wa.me/${clean}?text=${encoded}`;
};
